<!-- <div class="waiting-screen">
  <div class="d-flex flex-column align-items-center card">
    <img
      src="../../../../assets/no-result.PNG"
      alt="Mulher em pé segurando notebook"
    />
    <h4>Sua empresa ainda não foi ativada</h4>
    <p class="text-muted">
      Caso ainda não tenha feito o pagamento, segue o código PIX:
    </p>
    <qrcode
      qrdata="pixCode"
      [width]="210"
      [errorCorrectionLevel]="'H'"
    ></qrcode>
    <button
      class="btn btn-outline-primary mt-2 mb-2"
      (click)="copyCodeToClipboard()"
    >
      Copiar código Pix
    </button>
    <button
      routerLink="/access/context"
      class="btn text-primary w-100"
      type="button"
      title="Esqueceu sua senha?"
    >
      <i class="fa-solid fa-arrow-left-long mr-3"></i>
      Voltar
    </button>
  </div>
</div> -->
<div class="waiting-screen">
  <div id="container">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-12 text-center">
            <img src="../../../../assets/ico/money.svg" class="money-img" />
            <p class="text-muted">Aguardando Pagamento!</p>
            <p class="description">
              Como o pagamento da sua ativação de conta é feito via PIX, o
              sistema valida tudo rapidinho…
            </p>
            <p class="description">
              Assim que realizar o pagamento, tente o acesso outra vez.
            </p>
            <div class="mt-3" *ngIf="pixCode">
              <qrcode
                [qrdata]="pixCode"
                [width]="190"
                [errorCorrectionLevel]="'H'"
              ></qrcode>
            </div>
          </div>
          <div class="col-12">
            <div class="d-flex justify-content-between">
              <div class="link-btn" routerLink="/access/context">
                <span>
                  <i class="fa fa-arrow-left"></i> &nbsp; Voltar ao Login</span
                >
              </div>
              <div class="link-btn" (click)="copyCodeToClipboard()">
                <span>
                  Copiar código PIX &nbsp;
                  <i class="fa fa-arrow-right"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
